import React from "react";
import {shallowEqual, useSelector} from "react-redux";
import {LightboxContentInner} from "./LightboxContentInner";
import {preprocessFile} from "./utils/preprocessFile";
import {getLightboxModalProps} from "./utils/getLightboxModalProps";

export function LightboxContent({ onClose }) {
    const currentIndex = useSelector(state => state.Lightbox.currentIndex);
    const file = useSelector(state => state.Lightbox.files[currentIndex], shallowEqual);
    const lightboxType = useSelector(state => state.Lightbox.lightboxType);

    if (!file)
        return null;

    const preprocessedFile = preprocessFile(file, null, lightboxType);
    const lightboxModalProps = getLightboxModalProps(preprocessedFile.lightboxProps);

    return (
        <div
            key={preprocessedFile.lightboxProps.file_id}
            className="lightbox-content-wrapper"
            onClick={onClose}
            {...lightboxModalProps}
        >
            <LightboxContentInner
                fileLightboxProps={preprocessedFile.lightboxProps}
            />
        </div>
    );
}
